/* eslint-disable */
<div style="max-width:403px;max-height:300px" id="container123"></div>
<template>
  <section class="section section-white content-padded" onload="init()">
    <el-form ref="form" :model="form" label-width="130px">
      <el-form-item label="店铺名称">
        <div>
          <el-col :span="8">
            <el-input v-model="form.name" placeholder="请先完成下方地理位置的选择"></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="店铺编号(英克ID)">
        <div>
          <el-col :span="8">
            <el-input v-model="form.number" placeholder=""></el-input>
          </el-col>
        </div>
        <div class="frm-tips">&nbsp;&nbsp;店铺编号必填，若没有英克ID请以：大写字母S+店铺名缩写+随机数做为店铺编号</div>
      </el-form-item>
      <el-form-item label="商家id">
        <div>
          <el-col :span="8">
            <el-input v-model="form.merchant_id" placeholder=""></el-input>
          </el-col>
        </div>
        <div class="frm-tips">&nbsp;&nbsp;第三方店铺需要填写商家id,没有则暂时不填</div>
      </el-form-item>
      <el-form-item label="门店平台">
        <el-select v-model="form.store_platform_str" placeholder="门店平台" @change="handlePlatform">
          <el-option label="怡康到家" value="0"></el-option>
          <el-option label="每一天" value="2"></el-option>
        </el-select>
      </el-form-item>
      <div v-show="false">
        <el-col>
          <el-input v-model="form.store_platform" placeholder=""></el-input>
        </el-col>
      </div>

      <el-form-item label="店铺类型">
        <el-checkbox-group v-model="form.shop_type_arr" @change="handleCheckedShoptypeChange">
          <el-checkbox v-for="shop in shop_type_list"
                       :label="shop.shop_type_id"
                       :key="shop.shop_type_id"
                       :value="shop.shop_type_name"> {{shop.shop_type_name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div v-show="false">
        <el-col>
          <el-input v-model="form.shop_type_str" placeholder=""></el-input>
        </el-col>
      </div>

      <el-form-item label="所属大区" prop="office_area_id">
        <!--<el-select v-model="form.office_area_name"  placeholder="所属大区" @change="handleOfficeChange">-->
        <!--<el-option  v-for="item in office_area" :key="item.area_id" :label="item.name" :value="item.name" >-->
        <!--</el-option>-->
        <!--</el-select>-->
        <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                     :options="office_area"
                     :props="{ checkStrictly: true }"
                     v-model="selected_office_area_id"
                     clearable>
        </el-cascader>
      </el-form-item>
      <div v-show="false">
        <el-col>
          <el-input v-model="form.office_area_id" placeholder=""></el-input>
        </el-col>
        <el-col>
          <el-input v-model="form.office_area_pid" placeholder=""></el-input>
        </el-col>
      </div>
      <el-form-item label="地理位置">
        <div class="frm-tips">店铺定位后保存店铺经纬度，才可以开启自提，否则店铺不支持自提功能</div>
        <el-cascader v-model="form.regions_id" :options="regions" @change="handleRegionChange"
                     style="width:200px"></el-cascader>
        <el-input v-model="form.address" id="keyword" placeholder="请输入地址" style="width:500px"></el-input>
        <el-button type="primary" @click="searchKeyword()">搜索定位</el-button>
      </el-form-item>
      <el-form-item label="地图定位">
        <div id="qqmap_container"></div>
      </el-form-item>
      <el-form-item label="电子围栏">
        <div id="qqglmap_container"></div>
      </el-form-item>
      <el-form-item inline="true" class="demo-form-inline" label="腾讯电子围栏地址">

        <el-col :span="10">
          <el-input readonly v-model="form.scope_tx" placeholder="电子围栏地址"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item inline="true" class="demo-form-inline" label="腾讯经纬度">
        <el-col :span="3">
          <el-input readonly v-model="form.lng" placeholder="经度"></el-input>
        </el-col>
        <el-col :span="1" class="content-center">-</el-col>
        <el-col :span="3">
          <el-input readonly v-model="form.lat" placeholder="纬度"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="form.contact" placeholder="联系人" style="width: 55%;"></el-input>
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input v-model="form.mobile" placeholder="请输入手机号" style="width: 55%;"></el-input>
      </el-form-item>
      <el-form-item label="固定电话">
        <el-input v-model="form.telephone" placeholder="请输入固定电话" style="width: 55%;"></el-input>
      </el-form-item>
      <el-form-item label="营业时间">
        <el-time-select placeholder="起始时间" v-model="startTime"
                        :picker-options="{ start: '00:00', step: '00:30', end: '24:00' }"></el-time-select>
        <el-time-select placeholder="结束时间" v-model="endTime"
                        :picker-options="{start: '00:00', step: '00:30', end: '24:00' , minTime: startTime }"></el-time-select>
        <p class="frm-tips">24小时制，如10：00-20：30</p>
      </el-form-item>
      <el-form-item label="店铺服务">
        <el-checkbox-group v-model="form.service_arr" @change="serviceFormat">
          <el-checkbox label="中医">中医</el-checkbox>
          <el-checkbox label="代煎">代煎</el-checkbox>
          <el-checkbox label="自提">自提</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div v-show="false">
        <el-col>
          <el-input v-model="form.service" placeholder=""></el-input>
        </el-col>
      </div>
      <!-- <el-form-item label="是否蜂鸟门店">
        <el-switch v-model="form.is_fenniao" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
      </el-form-item> -->
      <el-form-item label="延迟推送时间">
        <el-input v-model="form.push_count_down"   placeholder="时间范围：1-15/单位：分钟" style="width: 15%;"></el-input>
      </el-form-item>
      <el-form-item label="配送方式">
        <el-checkbox-group v-model="form.shipping_type_arr" @change="shippingTypeFormat">
          <el-checkbox label="1">蜂鸟</el-checkbox>
          <el-checkbox label="2">美团</el-checkbox>
          <el-checkbox label="3">达达</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div v-show="false">
        <el-col>
          <el-input v-model="form.shipping_type" placeholder=""></el-input>
        </el-col>
      </div>
      <el-form-item label="评分">
        <el-rate v-model="form.rate" show-score allow-half score-template="{value}"></el-rate>
      </el-form-item>
      <el-form-item label="起送门槛设置">
        <el-input v-model="form.threshold_setting"   placeholder="例如:20元起送" style="width: 15%;"></el-input> 元起送
      </el-form-item>
      <el-form-item label="配送描述" >
        <el-input v-model="form.delivery_spe" placeholder="请输入配送描述" style="width: 55%;"></el-input>
      </el-form-item>
      <el-form-item label="店铺LOGO">
        <div @click="handleImgPicker('logo')" class="upload-box">
          <img v-if="form.logo" :src="form.logo" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="店铺横幅广告">
        <div @click="handleImgPicker('banner')" class="upload-box">
          <img v-if="form.banner" :src="form.banner" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="自动上架商品" v-if="this.$store.getters.login_type != 'distributor'">
        <el-switch v-model="form.auto_sync_goods" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
        <div class="frm-tips">开启后，店铺自动上架总部商品; 取消自动下架后，将保留店铺已上架的商品</div>
      </el-form-item>
      <el-form-item label="审核商品" v-if="this.$store.getters.login_type != 'distributor' && system_mode === 'platform'">
        <el-switch v-model="form.is_audit_goods" inactive-color="#ff4949" active-color="#13ce66"></el-switch>
        <div class="frm-tips">开启后，店铺添加的自有商品，需要平台审核通过后才可以上架</div>
      </el-form-item>

      <!-- 升级平台模式  把自提全部开放 -->
      <!-- <el-form-item v-if="system_mode !== 'platform'" label="是否自提">-->
      <el-form-item label="是否自提">
        <el-switch v-if="!form.lng && !form.lat" disabled v-model="form.is_ziti" active-color="#13ce66"
                   inactive-color="#ff4949"></el-switch>
        <el-switch v-else v-model="form.is_ziti" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch v-model="form.is_valid" active-value="true" inactive-value="false" active-color="#13ce66"
                   inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item label="是否开启营业">
        <el-switch v-model="form.is_open" active-value="true" inactive-value="false" active-color="#13ce66"
                   inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item label="是否自动接单">
        <el-switch v-model="form.auto_receive" active-value="true" inactive-value="false" active-color="#13ce66"
                   inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <!--
    <el-form-item label="是否电商仓">
      <el-switch v-model="form.is_ec"  active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
    </el-form-item>
    -->
      <!--
    <el-form-item label="大区配送中心">
      <el-switch v-model="form.is_warehouse" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
    </el-form-item>
      -->
      <!-- <el-form-item label="支持门店配货">
        <el-switch v-model="form.is_delivery" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
      </el-form-item> -->
      <el-form-item label="是否开启快递配送">
        <el-switch v-model="form.isExpress" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item label="第三方门店">
        <el-switch v-model="form.is_third" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item label="第三方平台">
        <el-select v-model="form.is_third_plant" disabled placeholder="第三方平台">
          <el-option label="------" value=""></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="第三方收银平台" v-if="form.merchant_id > 0">
        <el-radio-group v-model="form.third_plant_type" disabled="disabled">
          <el-radio label="keruyun">客如云</el-radio>
          <el-radio label="meituan">美团</el-radio>
          <el-radio label="hualala">哗啦啦</el-radio>
          <el-radio label="tcsl">天财商龙</el-radio>
          <el-radio label="feie">飞鹅打印机</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="第三方门店id" v-if="form.merchant_id > 0">
        <el-input v-model="form.third_distributor_id" disabled="disabled" style="width: 55%;"></el-input>
      </el-form-item>
      <!--店铺图片-->
      <el-form-item label="*店铺图片">
        <div>
          <div class="pics-box">
            <ul class="goodspic-wrap">
              <draggable v-model="form.store_images" :options="dragIssuesOptions" class="components-view">
                <li v-for="(item, index) in form.store_images" :key='index' class="goodspic"
                    @mouseenter="storeImagesEnter0(index)" @mouseleave="storeImagesLeave0">
                  <!-- <img :src="wximageurl + item"/> -->
                  <el-image
                    ref="imageStoreRef"
                    :src="wximageurl + item"
                    show-progress
                    :preview-src-list="form.store_images"
                    fit="cover"
                  />
                  <div class="goodspic-mask" :class="(storeImagesCurrent == index) ? 'on' : ''">
                    <div class="iconfont icon-trash-alt" @click="removeStoreImages0(index)"></div>
                    <div class="iconfont icon-arrows-alt"></div>
                    <div @click="handlePreview(index)" class="iconfont icon-eye"></div>
                  </div>
                </li>
              </draggable>
            </ul>
            <div v-if="form.store_images.length < 9" class="upload-box" @click="handleStoreImagesChange0">
              <i class="iconfont icon-camera"></i>
            </div>
          </div>
          <div class="frm-tips">
            <p>1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）</p>
            <p>2. 拖动图片进行可排序</p>
          </div>
        </div>
        <imgPicker :dialog-visible="storeImagesDialog" :sc-status="isGetStoreImages" :is-most="multiple"
                   @chooseImg="pickStoreImages0" @closeImgDialog="closeStoreImagesDialog0"></imgPicker>
      </el-form-item>
      <!-- 店铺资质图片 -->
      <el-form-item label="*店铺资质图片">
        <div>
          <div class="pics-box">
            <ul class="goodspic-wrap">
              <draggable v-model="form.cert_images" :options="dragIssuesOptions" class="components-view">
                <li v-for="(item, index) in form.cert_images" :key='index' class="goodspic"
                    @mouseenter="storeImagesEnter2(index)" @mouseleave="storeImagesLeave2">
                  <!-- <img :src="wximageurl + item"/> -->
                  <el-image
                    ref="imageCertRef"
                    :src="wximageurl + item"
                    show-progress
                    :preview-src-list="form.cert_images"
                    fit="cover"
                  />
                  <div class="goodspic-mask" :class="(storeImagesCurrent2 == index) ? 'on' : ''">
                    <div class="iconfont icon-trash-alt" @click="removeStoreImages2(index)"></div>
                    <div class="iconfont icon-arrows-alt"></div>
                    <div @click="handleCertPreview(index)" class="iconfont icon-eye"></div>
                  </div>
                </li>
              </draggable>
            </ul>
            <div v-if="form.cert_images.length < 9" class="upload-box" @click="handleStoreImagesChange2">
              <i class="iconfont icon-camera"></i>
            </div>
          </div>
          <div class="frm-tips">
            <p>1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）</p>
            <p>2. 拖动图片进行可排序</p>
          </div>
        </div>
        <imgPicker :dialog-visible="storeImagesDialog2" :sc-status="isGetStoreImages2" :is-most="multiple2"
                   @chooseImg="pickStoreImages2" @closeImgDialog="closeStoreImagesDialog2"></imgPicker>
      </el-form-item>
      <el-form-item label="营业执照">
        <div @click="handleImgPicker('yyzz')" class="upload-box">
          <img v-if="form.yyzz" :src="form.yyzz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="营业执照编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.yyzzbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="食品经营许可证">
        <div @click="handleImgPicker('spjyxkz')" class="upload-box">
          <img v-if="form.spjyxkz" :src="form.spjyxkz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="食品经营许可证编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.spjyxkzbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="药品经营许可证">
        <div @click="handleImgPicker('ypjyxkz')" class="upload-box">
          <img v-if="form.ypjyxkz" :src="form.ypjyxkz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="药品经营许可证编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.ypjyxkzbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="医疗器械许可证">
        <div @click="handleImgPicker('ylqxxkz')" class="upload-box">
          <img v-if="form.ylqxxkz" :src="form.ylqxxkz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="医疗器械许可证编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.ylqxxkzbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="二类医疗器械许可证">
        <div @click="handleImgPicker('elylqxxkz')" class="upload-box">
          <img v-if="form.elylqxxkz" :src="form.elylqxxkz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="二类医疗器械许可证编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.elylqxxkzbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="三类医疗器械许可证">
        <div @click="handleImgPicker('slylqxxkz')" class="upload-box">
          <img v-if="form.slylqxxkz" :src="form.slylqxxkz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="三类医疗器械许可证编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.slylqxxkzbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="药师注册证">
        <div @click="handleImgPicker('yszcz')" class="upload-box">
          <img v-if="form.yszcz" :src="form.yszcz" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
      </el-form-item>
      <el-form-item label="药师注册证编号">
        <div>
          <el-col :span="6">
            <el-input v-model="form.yszczbh" placeholder=""></el-input>
          </el-col>
        </div>
      </el-form-item>
      <!-- 药师注册证 -->
      <!-- <el-form-item label="药师注册证">
        <div>
          <div class="pics-box">
            <ul class="goodspic-wrap">
              <draggable v-model="form.yszcz" :options="dragIssuesOptions" class="components-view">
                <li   v-for="(item, index) in form.yszcz" :key='index' class="goodspic"
                    @mouseenter="storeImagesEnter1(index)" @mouseleave="storeImagesLeave1">
                  <img :src="wximageurl + item"/>
                  <div class="goodspic-mask" :class="(storeImagesCurrent1 == index) ? 'on' : ''">
                    <div class="iconfont icon-trash-alt" @click="removeStoreImages1(index)"></div>
                    <div class="iconfont icon-arrows-alt"></div>
                  </div>
                </li>
              </draggable>
            </ul>
            <div v-if="form.yszcz == null || form.yszcz.length < 9" class="upload-box" @click="handleStoreImagesChange1">
              <i class="iconfont icon-camera"></i>
            </div>
          </div>
          <div class="frm-tips">
            <p>1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）</p>
            <p>2. 拖动图片进行可排序</p>
          </div>
        </div>
        <imgPicker :dialog-visible="storeImagesDialog1" :sc-status="isGetStoreImages1" :is-most="multiple1"
                   @chooseImg="pickStoreImages1" @closeImgDialog="closeStoreImagesDialog1"></imgPicker>
      </el-form-item> -->
      <div class="section-footer with-border content-center">
        <el-button size="large" @click="cancelSubmit">取消</el-button>
        <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' :
          '保存'}}
        </el-button>
      </div>
    </el-form>
    <div id="qqmap_infowin" v-show="qqmap_infowin_flag">
      <el-col>
        <el-button type="primary" @click="imp_poi(poi_info)">导入该位置信息</el-button>
      </el-col>
      <el-col>{{poi_info.name}}</el-col>
      <div class="frm-tips"> {{poi_info.address}}</div>
    </div>
    <div id="new_qqmap_info" v-show="new_qqmap_info_flag">
      <el-col>
        <el-button type="primary" @click="new_imp_poi(new_poi_info)">导入该位置</el-button>
      </el-col>
      <el-col></el-col>
      <div class="frm-tips"></div>
    </div>
    <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg"
               @closeImgDialog="closeImgDialog"></imgPicker>
  </section>
</template>
<script>
  import imgPicker from '@/components/imageselect'
  import district from '../../../common/district.json'
  import {saveDistributor, getDistributorInfo, getShopTypes} from '@/api/marketing'
  import {getOfficeArea} from "../../../api/marketing";
  import {getAreaManageList} from "../../../api/areamanage";
  import draggable from 'vuedraggable'

  // 取选中地区的值
  function getCascaderObj(val, opt) {
    return val.map(function (value, index, array) {
      for (var itm of opt) {
        if (itm.value === value) {
          opt = itm.children
          return itm
        }
      }
      return null
    })
  }

  function deleteOverlays(markersArray) {
   // alert(1);
    // console.log(markersArray)
    if (markersArray) {
      for (var i in markersArray) {
        markersArray[i].setMap(null)
      }
      markersArray.length = 0
    }
  }

  export default {
    components: {
      imgPicker,
      draggable,
    },
    data() {
      return {
        imgDialog: false,
        isGetImage: false,
        startTime: '08:00',
        endTime: '21:00',
        submitLoading: false,
        pickerImgType: 'logo',
        dragIssuesOptions: {
          animation: 300,
          forceFallback: true,
          scroll: true,
          handle: '.icon-arrows-alt',
          draggable: '.goodspic'
        },
        form: {
          is_valid: 'false',
          address: '',
          shop_type_arr: [],
          service_arr: [],
          shipping_type_arr: [],
          lng:'',
          lat:'',
          cert_images:[],
          store_images:[],
          threshold_setting:0,
          push_count_down:0,
          yyzz:'',
          spjyxkz:'',
          ypjyxkz:'',
          ylqxxkz:'',
          elylqxxkz:'',
          slylqxxkz:'',
          yszcz:'',
          yyzzbh:'',
          spjyxkzbh:'',
          ypjyxkzbh:'',
          ylqxxkzbh:'',
          elylqxxkzbh:'',
          slylqxxkzbh:'',
          yszczbh:''
        },
        distributor_id: 0,
        searchRegion: '',
        qqmap_infowin_flag: false,
        regions: district,
        office_area: [],
        selected_office_area_id: [],
        shop_type_list: [],
        searchService: [],
        markers: [],
        poi_info: [],
        markersArray: [],
        new_qqmap_info_flag: false,
        new_poi_info: [],
        new_infoWin: [],
        // store
        isGetStoreImages: false,
        storeImagesDialog: false,
        storeImagesCurrent: -1,
        storeImagesOldLen: 0,
        currentSku: -1,
        multiple: false,
        specImages: [],
        // cert
        isGetStoreImages2: false,
        storeImagesDialog2: false,
        storeImagesCurrent2: -1,
        storeImagesOldLen2: 0,
        currentSku2: -1,
        multiple2: false,
        specImages2: [],
        // yszcz
        isGetStoreImages1: false,
        storeImagesDialog1: false,
        storeImagesCurrent1: -1,
        storeImagesOldLen1: 0,
        currentSku1: -1,
        multiple1: false,
        specImages1: [],
        scope_tx: [],
        scope_gd: [],
        scope_bd: [],
        simplePath:'',
      }
    },
    methods: {
      handlePreview(idx) {
        console.log(this.$refs.imageStoreRef)
        if (this.$refs.imageStoreRef) {
          // 找到组件内部的 img 元素并触发点击
          console.log(this.$refs.imageStoreRef[idx].$el);
          const imgElement = this.$refs.imageStoreRef[idx].$el.querySelector('img');
          if (imgElement) {
            imgElement.click();
          }
        }
      },
      handleCertPreview(idx) {
        console.log(this.$refs.imageCertRef)
        if (this.$refs.imageCertRef) {
          // 找到组件内部的 img 元素并触发点击
          console.log(this.$refs.imageCertRef[idx].$el);
          const imgElement = this.$refs.imageCertRef[idx].$el.querySelector('img');
          if (imgElement) {
            imgElement.click();
          }
        }
      },
      getOfficeArea() {
        getAreaManageList({'format_flag': true}).then(response => {
          this.office_area = response.data.data;
        })
      },
      // jiangxd
      handleCheckedShoptypeChange(val) {
        // 前端处理数据结构，减少不必要的数据库查询，减轻服务器
        let arr = []
        for (let i of val) {
          for (let j of this.shop_type_list) {
            if (i == j.shop_type_id) {
              arr.push(j.shop_type_name)
            }
          }
        }
        this.form.shop_type_str = arr.join(',')
        this.form.shop_type_id = val.join(",")
        // console.log(this.form.shop_type_id)
        // console.log(this.form.shop_type_str)
      },
      // 门店平台
      handlePlatform(val) {
        this.form.store_platform = val
      },
      // 店铺服务格式化
      serviceFormat() {
        this.form.service = this.form.service_arr.join(",")
      },
      // 配送服务格式化
      shippingTypeFormat(val) {
        this.form.shipping_type = val.join(",")
        console.log(this.form.shipping_type)
      },
      // 大区名 和id 对应
      handleOfficeChange: function (val) {
        //分离出区域id 和区域父id
        var now_office_area_pid = val[0]
        this.selected_office_area_id[0] = now_office_area_pid;
        if (val.length > 1) {
          var now_office_area_id = val[1]
          this.selected_office_area_id[1] = now_office_area_id
        } else {
          var now_office_area_id = 0
        }
        this.form.office_area_id = now_office_area_id
        this.form.office_area_pid = now_office_area_pid
      },
      pickImg(data) {
        switch (this.pickerImgType) {
          case 'logo':
            this.form.logo = data.url
            break;
          case 'yyzz':
            this.form.yyzz = data.url
            break;
          case 'spjyxkz':
            this.form.spjyxkz = data.url
            break;
          case 'ypjyxkz':
            this.form.ypjyxkz = data.url
            break;
          case 'ylqxxkz':
            this.form.ylqxxkz = data.url
            break;
          case 'elylqxxkz':
            this.form.elylqxxkz = data.url
            break;
          case 'slylqxxkz':
            this.form.slylqxxkz = data.url
            break;
          case 'yszcz':
            this.form.yszcz = data.url
            break;
          default:
            this.form.banner = data.url
        }
        this.imgDialog = false
      },
      handleImgPicker(pickerImgType) {
        this.pickerImgType = pickerImgType
        this.imgDialog = true
        this.isGetImage = true
      },
      closeImgDialog() {
        this.imgDialog = false
        this.isGetImage = false
      },
      cancelSubmit() {
        this.$router.go(-1)
      },
      submitItemsActionConfirm() {
        this.submitLoading = true
        this.form.hour = this.startTime + '-' + this.endTime
        console.log(this.form.scope_tx)
        console.log(this.form)
        saveDistributor(this.form).then(res => {
          this.submitLoading = false
          this.$message({type: 'success', message: '保存店铺成功'})
          if (this.$store.getters.login_type != 'distributor') {
            this.$router.go(-1)
          }
        }).catch(error => {
          this.submitLoading = false
        })
      },
      handleRegionChange: function (value) {
        var vals = getCascaderObj(value, this.regions)
        this.form.regions_id = []
        this.form.regions = []
        for (var i = 0; i < vals.length; i++) {
          this.form.regions_id[i] = vals[i].value
          this.form.regions[i] = vals[i].label
        }

        if (this.form.regions[0] == '北京市' || this.form.regions[0] == '天津市' || this.form.regions[0] == '上海市' || this.form.regions[0] == '重庆市') {
          this.searchRegion = this.form.regions[0] + this.form.regions[2]
        } else {
          this.searchRegion = this.form.regions[0] + this.form.regions[1] + this.form.regions[2]
        }

      },
      qqmapinit: function (lat, lng) {
        // var center = new qq.maps.LatLng(39.916527, 116.397128);
        var center = new qq.maps.LatLng(lat, lng);
        var map = new qq.maps.Map(document.getElementById('qqmap_container'), {
          center: center,
          zoom: 13
        });
        //创建marker
        var marker = new qq.maps.Marker({
          position: center,
          map: map
        });
        var that = this;
        that.markersArray.push(marker)
        //设置Poi检索服务，用于本地检索、周边检索
        this.searchService = new qq.maps.SearchService({
          panel: document.getElementById('qqmap_rslist'),
          //检索成功的回调函数
          complete: function (results) {
            //设置回调函数参数
            var pois = results.detail.pois;
            console.log(results)
            var infoWin = new qq.maps.InfoWindow({
              map: map
            });
            var latlngBounds = new qq.maps.LatLngBounds();
            for (var i = 0, l = pois.length; i < l; i++) {
              var poi = pois[i];
              //扩展边界范围，用来包含搜索到的Poi点
              latlngBounds.extend(poi.latLng);
              (function (n) {
                var marker = new qq.maps.Marker({
                  map: map
                });
                marker.setPosition(pois[n].latLng);
                marker.setTitle(i + 1);
                that.markers.push(marker);
                qq.maps.event.addListener(marker, 'click', function () {
                  infoWin.open();
                  that.qqmap_infowin_flag = true
                  that.poi_info = pois[n] //将选点位置信息存入poi_info
                  infoWin.setContent(document.getElementById('qqmap_infowin'));
                  infoWin.setPosition(pois[n].latLng);

                });
              })(i);
            }
            //调整地图视野
            map.fitBounds(latlngBounds);
          },
          //若服务请求失败，则运行以下函数
          error: function () {
            this.$message.error('未查询到数据')
          }
        });
        //新增点击地图定位 移动mark定位
        var that = this;
        qq.maps.event.addListener(map, 'click', function (event) {
          deleteOverlays(that.markersArray)
          // deleteOverlays(that.new_infoWin)
          that.new_qqmap_info_flag = false
          // that.new_infoWin.close()
          var newmarker = new qq.maps.Marker({
            position: event.latLng,
            map: map
          });
          qq.maps.event.addListener(newmarker, 'click', function () {
            that.new_qqmap_info_flag = true
            var new_infoWin = new qq.maps.InfoWindow({
              map: map
            })
            // that.new_infoWin.push(new_infoWin)
            new_infoWin.open();
            new_infoWin.setContent(document.getElementById('new_qqmap_info'))
            new_infoWin.setPosition(newmarker.position);
            that.new_poi_info = newmarker.position
          });
          that.markersArray.push(newmarker)
          // 设置Marker是否可以被拖拽
          newmarker.setDraggable(true)
        });
      },
      qqglmapinit: function () {
        var simplePath=[]
        var latLng = []
        // 初始化地图
        var map = new TMap.Map('qqglmap_container', {
          zoom: 12, // 设置地图缩放级别
          center: new TMap.LatLng(34.259424, 108.947039) // 设置地图中心点坐标
        })

        this.distributor_id = this.$route.query.distributor_id
    //    console.log('this.$store.getters.login_type123',this.$store.getters.login_type)
        if (this.distributor_id || this.$store.getters.login_type === 'distributor') {

         // console.log('this.$store.getters.login_type',this.$store.getters.login_type)
          getDistributorInfo({distributor_id: this.distributor_id}).then(res => {


            if(res.data.data.scope_tx){
              simplePath=JSON.parse(res.data.data.scope_tx)
              simplePath.map((e)=>{
                //   console.log(e.x,e.y,'ffffff')
                latLng.push(new TMap.LatLng(e.x,e.y))
              })
              // var simplePath = [
              //   new TMap.LatLng(34.30932117471661, 108.87103709358178),
              //
              //   new TMap.LatLng(34.29146365456799, 108.81819604105237),
              //   new TMap.LatLng(34.27898948801592, 108.9015751066703)
              //
              // ];
              // 初始化几何图形及编辑器
           //   console.log(latLng,'latLng')
              var polygon = new TMap.MultiPolygon({
                map: map,
                geometries: [
                  {
                    paths: latLng
                  }
                ]
              })
              var actionmode=TMap.tools.constants.EDITOR_ACTION.INTERACT;
            }else{
              var polygon = new TMap.MultiPolygon({
                map: map

              })
              var actionmode=TMap.tools.constants.EDITOR_ACTION.DRAW;
            }

              new TMap.MultiMarker({
                id: 'marker-layer',
                map: map,
                styles: {
                  marker: new TMap.MarkerStyle({
                    width: 25,
                    height: 35,
                    anchor: {x: 16, y: 32},
                    src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
                  })
                },
                geometries: [{
                  id: 'demo',
                  styleId: 'marker',
                  position: new TMap.LatLng(res.data.data.lat, res.data.data.lng),
                  properties: {
                    title: 'marker'
                  }
                }]
              })
            //https://lbs.qq.com/webDemoCenter/glAPI/glEditor/toolEditor 电子围栏
              var editor = new TMap.tools.GeometryEditor({
                // TMap.tools.GeometryEditor 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor
                map: map, // 编辑器绑定的地图对象
                overlayList: [
                  // 可编辑图层 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor#4
                  {
                    overlay: polygon,
                    id: 'polygon'
                  }
                ],
                // actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
                // actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
                actionMode:actionmode,
                activeOverlayId: 'polygon', // 激活图层
                selectable: true, // 开启点选功能
                snappable: true // 开启吸附
              })
              // 监听绘制结束事件，获取绘制几何图形
              editor.on('draw_complete', (geometry) => {
                // 判断当前处于编辑状态的图层id是否是overlayList中id为rectangle（矩形）图层
                if (editor.getActiveOverlay().id === 'polygon') {

                  // if(this.){}


                  // 获取矩形顶点坐标
                  var id = geometry.id
                  var geo = polygon.geometries.filter(function (item) {
                    return item.id === id
                  })
            // console.log(geo[0].paths)
                  var scope_tx = JSON.stringify(geo[0].paths)

                  this.form.scope_tx = scope_tx
                }
              })

            // 监听删除、修改、拆分、合并完成事件
            let evtList = ['adjust','delete'];
            evtList.forEach(evtName => {
              editor.on(evtName + '_complete', evtResult => {
                // console.log( evtResult['paths']);
                var scope_tx = JSON.stringify(evtResult['paths'])
                if(evtName=='delete'){
                  scope_tx='';
                }
                console.log(evtName, evtResult);
                this.form.scope_tx = scope_tx
              });
            });

          })


        }else{

          var polygon = new TMap.MultiPolygon({
            map: map,

          })
          new TMap.MultiMarker({
            id: 'marker-layer',
            map: map,
            styles: {
              marker: new TMap.MarkerStyle({
                width: 25,
                height: 35,
                anchor: {x: 16, y: 32},
                src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
              })
            },
            geometries: [{
              id: 'demo',
              styleId: 'marker',
              position: new TMap.LatLng(34.259424, 108.947039),
              properties: {
                title: 'marker'
              }
            }]
          })
          var editor = new TMap.tools.GeometryEditor({
            // TMap.tools.GeometryEditor 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor
            map: map, // 编辑器绑定的地图对象
            overlayList: [
              // 可编辑图层 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor#4
              {
                overlay: polygon,
                id: 'polygon'
              }
            ],
            actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
            activeOverlayId: 'polygon', // 激活图层
            snappable: true // 开启吸附
          })


          // 监听绘制结束事件，获取绘制几何图形
          editor.on('draw_complete', (geometry) => {
            // 判断当前处于编辑状态的图层id是否是overlayList中id为rectangle（矩形）图层
            if (editor.getActiveOverlay().id === 'polygon') {

              // 获取矩形顶点坐标
              var id = geometry.id
              var geo = polygon.geometries.filter(function (item) {
                return item.id === id
              })

              var scope_tx = JSON.stringify(geo[0].paths)

              this.form.scope_tx = scope_tx
            }
          })
        }



      },
      clearOverlays: function (overlays) { //清除地图上的marker
        var overlay;
        while (overlay = overlays.pop()) {
          overlay.setMap(null);
        }
      },
      searchKeyword: function () { //设置搜索的范围和关键字等属性
        if (!this.searchRegion) {
          this.$message({
            message: '请选择地区',
            type: 'warning'
          })
          return ''
        }
        if (!this.form.address) {
          this.$message({
            message: '请输入具体位置',
            type: 'warning'
          })
          return ''
        }
        var region = this.searchRegion;
        var keyword = this.form.address;
        var pageIndex = 0;
        var pageCapacity = 5;
        this.clearOverlays(this.markers);
        //根据输入的城市设置搜索范围
        this.searchService.setLocation(region);
        //设置搜索页码
        this.searchService.setPageIndex(pageIndex);
        //设置每页的结果数
        this.searchService.setPageCapacity(pageCapacity);
        //根据输入的关键字在搜索范围内检索
        this.searchService.search(keyword);
      },
      imp_poi: function (poi_info) {
        this.form.name = poi_info.name
        this.form.lng = poi_info.latLng.lng
        this.form.lat = poi_info.latLng.lat
        this.form.address = poi_info.address.substr(this.searchRegion.length + 1)
      },
      // 移动标记增加定位
      new_imp_poi: function (new_poi_info) {
        console.log(new_poi_info)
        this.form.lng = new_poi_info.lng
        this.form.lat = new_poi_info.lat
      },
      removeByValue: function (arr, val) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == val) {
            arr.splice(i, 1);
            break;
          }
        }
        return arr
      },
      getShopTypesData() {
        getShopTypes().then(res => {
          this.shop_type_list = res.data.data.list
        })
      },
      handleStoreImagesChange0() {
        this.storeImagesDialog = true
        this.isGetStoreImages = true
        this.multiple = true
      },
      closeStoreImagesDialog0() {
        console.log('close211')
        this.storeImagesDialog = false
        this.isGetStoreImages = false
      },
      storeImagesEnter0(index) {
        console.log('storeImagesEnter0')
        this.storeImagesCurrent = index
      },
      storeImagesLeave0() {
        console.log('storeImagesLeave0')
        this.storeImagesCurrent = -1
      },
      removeStoreImages0: function (index) {
        this.form.store_images.splice(index, 1)
        this.storeImagesOldLen = this.form.store_images.length
      },
      pickStoreImages0(data) {
        if (this.currentSku2 === -1) {
          if (this.storeImagesOldLen + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          } else {
            if (data.length != 0) {
              data.forEach(data => {
                if (data && data.url !== '') {
                  this.form.store_images.push(data.url)
                  this.storeImagesOldLen = this.form.store_images.length
                }
              })
            }
          }
        } else {
          if (this.specImages[this.currentSku].item_image_url.length + data.length > 5) {
            this.$message.error('最多添加5张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages[this.currentSku].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku = -1
        }
        this.storeImagesDialog = false
        this.isGetStoreImages = false
      },
      handleStoreImagesChange2() {
        this.storeImagesDialog2 = true
        this.isGetStoreImages2 = true
        this.multiple2 = true
      },
      closeStoreImagesDialog2() {
        console.log('close211')
        this.storeImagesDialog2 = false
        this.isGetStoreImages2 = false
      },
      storeImagesEnter2(index) {
        console.log('storeImagesEnter2')
        this.storeImagesCurrent2 = index
      },
      storeImagesLeave2() {
        console.log('storeImagesLeave2')
        this.storeImagesCurrent2 = -1
      },
      removeStoreImages2: function (index) {
        this.form.cert_images.splice(index, 1)
        this.storeImagesOldLen2 = this.form.cert_images.length
      },
      pickStoreImages2(data) {
        console.log(data)
        if (this.currentSku2 === -1) {
          if (this.storeImagesOldLen2 + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          } else {
            if (data.length != 0) {
              data.forEach(data => {
                if (data && data.url !== '') {
                  this.form.cert_images.push(data.url)
                  this.storeImagesOldLen2 = this.form.cert_images.length
                }
              })
            }
          }
        } else {
          if (this.specImages2[this.currentSku2].item_image_url.length + data.length > 5) {
            this.$message.error('最多添加5张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages2[this.currentSku2].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku2 = -1
        }
        this.storeImagesDialog2 = false
        this.isGetStoreImages2 = false
      },
      handleStoreImagesChange1() {
        this.storeImagesDialog1 = true
        this.isGetStoreImages1 = true
        this.multiple1 = true
      },
      closeStoreImagesDialog1() {
        this.storeImagesDialog1 = false
        this.isGetStoreImages1 = false
      },
      storeImagesEnter1(index) {
        this.storeImagesCurrent1 = index
      },
      storeImagesLeave1() {
        this.storeImagesCurrent1 = -1
      },
      removeStoreImages1: function (index) {
        this.form.yszcz.splice(index, 1)
        this.storeImagesOldLen1 = this.form.yszcz.length
      },
      pickStoreImages1(data) {
        console.log(data)
        if (this.currentSku1 === -1) {
          if (this.storeImagesOldLen1 + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          } else {
            if (data.length != 0) {
              data.forEach(data => {
                if (data && data.url !== '') {
                  this.form.yszcz.push(data.url)
                  this.storeImagesOldLen1 = this.form.yszcz.length
                }
              })
            }
          }
        } else {
          if (this.specImages1[this.currentSku1].item_image_url.length + data.length > 9) {
            this.$message.error('最多添加9张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages1[this.currentSku1].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku1 = -1
        }
        this.storeImagesDialog1 = false
        this.isGetStoreImages1 = false
      },
    },
    mounted() {
      this.getShopTypesData()
      this.distributor_id = this.$route.query.distributor_id
      this.copy_dis_id = this.$route.query.copy_dis_id // 复制店铺
      if (this.distributor_id || this.$store.getters.login_type == 'distributor') {
        // 编辑店铺
        getDistributorInfo({distributor_id: this.distributor_id}).then(res => {
          this.form = res.data.data
          this.form.threshold_setting = this.form.threshold_setting/100;
          this.scope_tx = res.data.data.scope_tx
          if (res.data.data.hour) {
            // 处理营业时间的格式
            var open_time = res.data.data.hour.split('-')
            this.startTime = open_time[0]
            this.endTime = open_time[1]
          }
          // 服务
          // 选中大区
          this.selected_office_area_id[0] = this.form.office_area_pid
          if (this.form.office_area_id > 0) {
            this.selected_office_area_id[1] = this.form.office_area_id
          }
          // 等待店铺数据选中后
          this.getOfficeArea();
          this.searchRegion = this.form.area
          if (!this.form.lat) {
            this.qqmapinit(34.259424, 108.947039)
          } else {
            this.qqmapinit(this.form.lat, this.form.lng)
          }
        })
      } else if (this.copy_dis_id) {
        // 复制店铺
        getDistributorInfo({distributor_id: this.copy_dis_id}).then(res => {
          // delete res.data.data.distributor_id // 移除店铺ID，走新增店铺的逻辑，而不是编辑店铺。
          res.data.data.distributor_id = 0 // 移除店铺ID，走新增店铺的逻辑，而不是编辑店铺。
          res.data.data.number = 0 // 复制店铺的时候清空原店铺英克ID，避免人为操作失误，导致数据提交。
          this.form = res.data.data
          console.log('复制店铺', this.form)
          this.form.threshold_setting = this.form.threshold_setting/100;
          this.scope_tx = res.data.data.scope_tx
          if (res.data.data.hour) {
            // 处理营业时间的格式
            var open_time = res.data.data.hour.split('-')
            this.startTime = open_time[0]
            this.endTime = open_time[1]
          }
          // 服务
          // 选中大区
          this.selected_office_area_id[0] = this.form.office_area_pid
          if (this.form.office_area_id > 0) {
            this.selected_office_area_id[1] = this.form.office_area_id
          }
          // 等待店铺数据选中后
          this.getOfficeArea();
          this.searchRegion = this.form.area
          if (!this.form.lat) {
            this.qqmapinit(34.259424, 108.947039)
          } else {
            this.qqmapinit(this.form.lat, this.form.lng)
          }
        })
      } else {
        // 添加门店时初始化地图
        this.qqmapinit(34.259424, 108.947039)
        // 新增店铺的二级区域
        this.getOfficeArea();
      }
      this.qqglmapinit()
    }
  }
</script>

<style lang="scss">
  .bm-view {
    width: 100%;
    height: 300px;
  }

  #qqmap_rslist {
    border-right: 1px solid #e7e7eb;
  }

  #qqmap_container {
    float: left;
    width: 800px;
    height: 400px;
  }
  #qqglmap_container{
    float: left;
    width: 800px;
    height: 400px;
  }

  .checkbox {
    background-color: white;
    border-radius: 0px;
    border: 1px solid #d3d3d3;
    width: 20px;
    height: 20px;
    display: inline-block;
    text-align: center;
    vertical-align: bottom;
    line-height: 20px;
  }

  .pics-box {
    overflow: hidden;

    .goodspic-wrap {
      float: left;
      margin-right: 5px;
      overflow: hidden;

      .goodspic {
        position: relative;
        float: left;
        width: 120px;
        height: 120px;
        margin: 0 5px 10px;
        border: 1px solid #ddd;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        .goodspic-mask {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, .2);
          cursor: pointer;

          &.on {
            display: flex !important;
            align-items: center;
            justify-content: center;
          }

          .iconfont {
            margin: 0 8px;
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }
  }

  .upload-box {
    display: inline-block;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;

    .iconfont {
      font-size: 30px;
      color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// distributor_editor.vue?3700d438